export default class StickyObserver {
	constructor({ elements }) {
		this._elements = elements;
		this._stickyElement = document.querySelector('.call-to-action--sticky');
		this._sentinel = document.querySelector('.cta-sentinel');
		this._rootMargin = this._elements[0].rootMargin || '0px 0px 100px';

		if (this._elements.length && this._stickyElement) {
			const visibilityObserver = new IntersectionObserver(
				(entries) => {
					const anyPartiallyVisible = entries.some((entry) => entry.intersectionRatio > 0);
					if (!anyPartiallyVisible) {
						this._stickyElement.classList.add('show');
					} else {
						this._stickyElement.classList.remove('show');
					}
				},
				{ rootMargin: this._rootMargin, threshold: [0] }
			);

			this._elements.forEach((el) => visibilityObserver.observe(el));
		}

		if (this._sentinel) {
			const boundaryObserver = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting) {
						this._stickyElement.classList.add('stop');
					} else {
						this._stickyElement.classList.remove('stop');
					}
				},
				{ rootMargin: '0px', threshold: 1.0 }
			);

			boundaryObserver.observe(this._sentinel);
		}
	}
}
